<script setup lang="ts">
const siteUrl = useSiteUrl()
</script>

<template>
    <!-- register -->
    <section
        class="bg-[#FFBF00] w-full flex items-center justify-center h-[212px] lg:h-[258px] bg-[url(/home/img/home/payjibExchange-mobile.svg)] lg:bg-[url(/home/img/home/payjibExchange.svg)] bg-cover bg-no-repeat px-6 lg:px-24">
        <BaseContainer>
            <div
                class="w-full h-full flex flex-col lg:flex-row gap-4 lg:gap-0 items-center justify-center lg:items-end lg:justify-between ">
                <h2
                    class="flex flex-col items-center  lg:items-start text-[24px] lg:text-[40px] font-medium text-[#2E2EE5]">
                    <span class="flex items-center gap-2">
                        <span>حواله ارز</span>
                        <span class="font-black text-[24px] lg:text-[47px]">امن و به‌صرفه</span>
                    </span>
                    <span class="flex items-center gap-2">
                        <span>را با ما تجربه کنید.</span>
                    </span>
                </h2>
                <div class="lg:h-full lg:flex lg:items-end">
                    <UiButton id="login-btn2" :href="siteUrl('/auth/register')"
                        class="bg-[#2E2EE5] w-[128px] h-[41px] lg:w-[167px] lg:h-[61px] lg:text-xl font-bold"
                        :link="true" :rounded="true" :external="true">
                        شروع ثبت نام
                    </UiButton>
                </div>

            </div>
        </BaseContainer>
    </section>

</template>
